import * as models from "./api/models";

export default function isSecuredDepositKey(value: string): value is models.SecuredDepositKeys {
    return !!Object.values(models.SecuredDepositKeys).find((key) => key === value);
}
